export default __webpack_public_path__ + "resources/icons/n211-7b8a.png";